import template from './terms-dialog.html';
import _ from 'lodash';

@Inject('$ngRedux', 'Notifications')
export class TermsDialogController {
  $onChanges(changes) {
    const { term } = changes;

    if (term && !_.isEmpty(term.currentValue)) {
      this.open();
    }
  }

  open() {
    this.Notifications.showComplexDialog({
      template,
      size: 'lg',
      resolve: {
        term: () => this.term,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-dialog/terms-dialog-controller.js